export default {
    none: 0,
    addButton: 1,
    deleteButton: 2,
    searchButton: 4,
    importButton: 8,
    exportButton: 16,
    extendButton: 32

    ,
    default: 1 | 4,
    addAndSearchAndImport: 1 | 4 | 8,
    addAndSearchAndImportAndExport: 1 | 4 | 8 | 16

}
